export default __webpack_public_path__ + "0d31bca.png";